import React, { memo, useCallback, useMemo } from 'react'
import type { PartnerInvoice, PendingInvoiceAction } from 'src/interfaces/invoice'
import { InvoiceActionVerb } from 'src/constants/invoice/enums'
import { buildInvoiceLabels } from 'src/utils/invoiceLabels'
import { getAvailableInvoiceActions } from 'src/utils/invoiceActions'
import { InvoiceActionsMenu } from './InvoiceActionsMenu'

interface Props {
  invoice: PartnerInvoice
  /** The parent composed invoice's label, so the modal title reads the same either way. */
  composedInvoiceLabel: string
  onRunAction(action: PendingInvoiceAction): void
}

const PartnerInvoiceActionsCellComponent = ({
  invoice,
  composedInvoiceLabel,
  onRunAction,
}: Props) => {
  const verbs = useMemo(() => {
    return getAvailableInvoiceActions(invoice)
  }, [invoice])

  // A one-invoice run is the same payload shape as a composed run, so it flows through the
  // same modal and the same saga loop.
  const handleSelect = useCallback(
    (verb: InvoiceActionVerb) => {
      onRunAction({
        verb,
        invoiceIds: [invoice.id],
        composedInvoiceLabel,
        invoiceLabels: buildInvoiceLabels([invoice]),
      })
    },
    [invoice, composedInvoiceLabel, onRunAction],
  )

  return (
    <InvoiceActionsMenu
      verbs={verbs}
      dataTestId={`partner-invoices-list-actions-${invoice.id}`}
      onSelect={handleSelect}
    />
  )
}

export const PartnerInvoiceActionsCell = memo(PartnerInvoiceActionsCellComponent)
